const applicationIds = Object.freeze({
  mipe: 'E2AB3F04-B958-4755-8A1B-DA0B75920997',
  securityPortal: '29E29DB3-3E4B-440D-9D2A-7B855DF48333',
  reportsPortal: '71C91732-5E60-47A6-98BE-33C8A3AD5162',
  financePortal: '153125D6-DEC8-420F-9B14-2238FCB4B1BC',
  detickets: 'D112A000-B099-476A-A4EA-8C010C1EA526',
  portalPadres: 'FB7FCF39-0EA8-4106-9157-D9BE1BB99544',
  remProPortal: '964EB4C0-FB90-4F2E-A79F-B726D4E20077',
  digitalSignature: '48A453F8-01A5-4EBD-B187-DEFF0BEFC580',
  technologyAssistance: '6944A8F7-7F89-4CEB-AD45-537BDC0A4B1E',
  caat: '6944A8F7-7F89-4CEB-AD45-537BDC0A4B1E',
  DEAlerts: '090DB152-001B-4D7E-AA46-6BD9B66D1D49',
  Sipaee: '81A93CBF-2D21-4FFD-879A-B5AF80C294DB'
});

export default applicationIds;
